import { AfterViewInit, Component, Injectable, NgZone, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subscription, merge } from 'rxjs';
import { MediaChange } from '@angular/flex-layout';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from "src/app/shared/services/login.service";
import { ScreensService } from 'src/app/shared/services/screens.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject, Observable, of as observableOf } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from '@angular/material/dialog';
import { ProfileComponent } from "src/app/user/profile/profile.component";
import { AboutUsComponent } from "src/app/user/about-us/about-us.component";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { environment } from "../../../environments/environment";
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CommonService } from "src/app/shared/services/common.service";
import {AsignUserRoleService} from '../../shared/services/asign-user-role.service';
import {CommonPermissionService} from '../../shared/services/common-permission.service';
import { ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VersionAlertComponent } from '../version-alert/version-alert.component';
import { duration } from 'moment';
import { constants } from 'src/app/shared/common/contants';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { ScreenPermissionServiceService } from 'src/app/shared/services/screen-permission-service.service';
import { LocalStorageEventServiceService } from 'src/app/shared/services/local-storage-event-service.service';
import { GlobalSearchService } from 'src/app/shared/services/global-search.service';
import { MicrosoftAuthBaseService } from 'src/app/shared/services/microsoft-auth-base.service';

export class FileNode {
  children: FileNode[];
  text: string;
  urlPath: String;
  screenType: String;
  screenName: String;
  icon: String;
  morder: Number;
}

export interface Profile {
  name: string;
  value: string;
  icon: String;
}


@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  login = { username: "", password: "" };
  opened = false;
  over = "over";
  expandHeight = "39px";
  collapseHeight = "39px";
  displayMode = "flat";
  watcher: Subscription;

  headerNameHtml = "";
  tableName = "";
  screenType = "";
  userName: any;
  userFirstLastName: any;
  userIcon;
  menus: any;
  rows: any = [];
  values: number[];
  userDetails: any = [];
  nestedTreeControl: NestedTreeControl<FileNode>;
  nestedDataSource: MatTreeNestedDataSource<FileNode>;
  dataChange: BehaviorSubject<FileNode[]> = new BehaviorSubject<FileNode[]>([]);

  backgroundColorMenuHeader = "";

  backgroundColorSideMenu = "";

  environmentKnowing = "";

  dnsnames:any=[];
  name;
  defaultLoginDns:any;
  isEnabled = false;
  users
  veevares:any
  user
  vaultids:any=[];
  defaultId:number;
  toggleValue;
  toggleSelect : boolean;
  toolTipStatus = "";
  confirmationMsg;
  togglestate;
  showToggle;
  latestVaultAPIversion;
  currentVaultAPIVersion;
  showVaultversionAlert = false;
  catalogRecords;
  idleTimeout;
  hideNav = false;
  private routeSub?: Subscription;
  //  private readonly HIDE_NAV_ROUTES: string[] = [
  //   '/user/Menubar/alert-product-mapping',
  //   '/user/Menubar/jsignal-pssTemplates',
  //   '/user/Menubar/jsignal-productStrategy',
  //   '/user/Menubar/jsip-Alert',
  //   '/user/Menubar/alert-product-mapping',
  //   '/user/Menubar/jsip-alertSummary',
  //   '/user/Menubar/jsignal-reviewApprove',
  //   '/user/Menubar/jsignal-reviewActivites',
  //   '/user/Menubar/jsignal-meddraBrowser',
  //   '/user/Menubar/jsip-HARequest',
  //   '/user/Menubar/jsip-MyTasks',
  //   '/user/Menubar/jsip-Meetings',
  //   '/user/Menubar/jsip-KeyChanges',
  //   '/user/Menubar/deviationManagement'
  // ];
  @ViewChild('myToggle') myToggle: any; // Reference to the mat-slide-toggle element
   private channel = new BroadcastChannel('user-activity-channel');
  private idleTimer: any;
  timeoutMs: number;
  durationValue: number;
  //  private idleTimeout = 1 * 60 * 1000; // 15 minutes in ms
// sectionsToHideHeader = [
//     "Product Safety Strategy",
//     "Configuration-info",
//     "Product Safety Strategy Template",
//     "Review & Approve",
//     "review-info",
//     "MedDRA-info",
    
//     // Add more as needed
//   ];
  //  sectionsToHideSidenav = [
  //   "Product Safety Strategy",
  //   "Configuration-info",
  //   "Product Safety Strategy Template",
  //   "Review & Approve",
  //   "review-info",
  //  ]
    currentGroup: string | null = null;
  currentSubmenu: any = null;
   showProductHeader = true;
    isSidenavOpen = true;
  selectedTopNavItem: any;
  currentSection!: string;
   defaultToolbarItems: any[] = []; 
   isRouteView: boolean;
  
// ================ TOP NAVIGATION CONFIGURATION ================
// topNavItems: any[] = [
//   { 
//     label: "Home", 
//     icon: "home", 
//     section: "Home", 
//     isRoute: false,
//     subToolbarItems: []
//   },
//   {
//     label: "Configuration",
//     icon: "settings",
//     section: "Configuration-info",
//     isRoute: false,
//     subToolbarItems: []
//   },
//   { 
//     label: "Alerts", 
//     icon: "notification_important", 
//     section: "Alerts", 
//     isRoute: false,
//     subToolbarItems: []
//   },
//   { 
//     label: "Dictionary", 
//     icon: "find_in_page", 
//     section: "Dictionary", 
//     isRoute: false,
//     subToolbarItems: []
//   }
// ];

topNavItems: any[] = [];

selectedCategory: string = 'Review Activities';

searchText: string = '';
searchTimer: any;
showSuggestions: boolean = false;

productList: any[] = [];

reviewActivtyList: any[] = [];

alertList: any[] = [];

  constructor(
    private router: Router,
    media: MediaObserver,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private spinner: NgxUiLoaderService,
    private loginService: LoginService,
    private screenService: ScreensService,
    private snackbar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService,
    private asignUserRoleService:AsignUserRoleService,
    private commonPermissionService:CommonPermissionService,
    private cdr: ChangeDetectorRef,
    private microsoftAuthService: MicrosoftAuthBaseService,
    private sanitizer: DomSanitizer,
    private constants: constants,private ngZone: NgZone,
    private storeEvents:LocalStorageEventServiceService,
    private etlService: EtlService,
    private screenPermissionServiceService:ScreenPermissionServiceService,
    private globalSearchService:GlobalSearchService
  ) {
    this.nestedTreeControl = new NestedTreeControl<FileNode>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();

    this.dataChange.subscribe(data => this.nestedDataSource.data = data);

    this.watcher = media.asObservable().subscribe((change:MediaChange[]) => {
        this.opened = false;
        this.over = "over";
    });

    this.routeSub = this.router.events
    .pipe(filter(e => e instanceof NavigationEnd))
    .subscribe((e: NavigationEnd) => {
      this.updateHideNav(e.urlAfterRedirects);

      // Update saved state based on current route
      const currentRoute = this.getCurrentRouteSegment();
      if (currentRoute && this.topNavItems) {
        for (const parent of this.topNavItems) {
          const matchingItem = parent.subToolbarItems?.find(
            (item: any) => item.urlPath === currentRoute
          );
          if (matchingItem) {
            localStorage.setItem("selectedParentLabel", parent.label);
            localStorage.setItem("currentSection", matchingItem.screenName);
            break;
          }
        }
      }

    });
  }

private updateHideNav(url: string): void {
  // Hide nav if URL contains jsip- (handles all nested routes automatically)
  this.hideNav = url.includes('jsip-');
}
  openPannel(m) {
    if (m._expanded == true) {
      return true;
    } else {
      return false;
    }
  }

  userProfile: Profile[] = [
    { name: 'Profile', value: 'Profile', icon: 'fas fa-user-alt iconStyle' },
    { name: 'About', value: 'aboutUs', icon: 'far fa-address-card iconStyle'},
    { name: 'Log Out', value: 'logOut', icon: 'fas fa-sign-out-alt iconStyle' },
  ];

  // Ng on initialize
  async ngOnInit() {
   this.storeEvents.subMenuCurrentSection$.subscribe(v => {
        if(v){
          this.currentSection = v
        }
  });
     const currentUrl = this.router.url;
     console.log(currentUrl)
     const parts = currentUrl.split('/'); // Split the string by "/"
     const valueAfterLastSlash = parts[parts.length - 1]; // Get the last element of the array
     console.log(valueAfterLastSlash)
      this.currentSection =this.getChildSectionByRoute(valueAfterLastSlash)
      console.log( this.topNavItems);
      
    //   localStorage.getItem("currentSection") || "Product Safety Strategy Template";
    // if(this.currentSection == "Product Safety Strategy Template"){
    // this.selectedTopNavItem = this.topNavItems?.[1];

    // }else{
      
    // this.selectedTopNavItem = this.topNavItems?.[0];
    // }
    this.selectedTopNavItem = this.getParentLabelByRoute(valueAfterLastSlash)
 this.updateHideNav(this.router.url);
    console.log(this.route.url+"---route")
    console.log(this.router.url+"---> router")
     console.log(valueAfterLastSlash)
     const params = new URLSearchParams(valueAfterLastSlash.split('?')[1]);
     const tableName = params.get('tableName');

    console.log(tableName);
    if(tableName){
      console.log("Inside of tablename")
       this.screenPermissionServiceService.load(tableName).subscribe();
    }else{
        console.log("Inside of valueAfterLastSlash")
        this.screenPermissionServiceService.load(valueAfterLastSlash).subscribe();
    }
    this.storeCatalogCsvRecord();
    this.storeAuditCatalog();
    var userName = localStorage.getItem("AuthUsername");

    console.log(userName);

    let userData: any = await this.commonService.retrieveSingleRecordService("users", "username", userName);

    let userid = userData[0].userid;
    console.log(userid)
    this.dnsDropDown(userid);
    this.environmentKnowing = environment.environmentKnowing;

    //Get userName from localStorage.
    this.userName = localStorage.getItem("AuthUsername");

    this.userFirstLastName = localStorage.getItem("AuthUser");

    this.userDetails = this.userFirstLastName.split(' ');
    this.userIcon = "";
    console.log(this.userDetails)
    // for (let i = 0; i < this.userDetails.length; i++) {
    //   this.userIcon = this.userIcon+""+this.userDetails[i].charAt(0);
    // }
    console.log(this.userIcon)

    this.userIcon = this.userDetails[0].charAt(0) + this.userDetails[1].charAt(0)
    //reterive user Role By Tenant Id And UserId
    this.asignUserRoleService.reteriveuserRoleByTenantIdAndUserId(userid).subscribe(response => {

      console.log("roletype")
      if (response.error === true) {

        console.log(response);

        this.spinner.stop();

        this.snackbar.open(response.statusMessage, "OK", {duration: 5000});

      } else {
        this.spinner.stop();
        this.screenService.retrieveWeb(response).subscribe(menus => {
          this.menus = menus[1];
          // this.items = this.getBooks();
          this.dataChange.next(this.menus);
          console.log(this.menus)

           //Process menus and build navigation based on MODULE field
          this.processMenusAndBuildNavigation(this.menus);
          //Restore the selected state after menus are loaded
          this.restoreNavigationState();

            console.log('Menus loaded:', this.menus);
            console.log('Top Nav built:', this.topNavItems);
              console.log(currentUrl)
              if(currentUrl === "/user/Menubar/home"){
                if(this.menus.length == 1 && this.menus[0].screenName =="JSIP"){
                  this.router.navigate(['user', 'Menubar', "jsip-signalmanagement"]);
                }
              }
        });
      }


    })


    //this.items = new TreeviewItem(this.menus)
    // this.route.queryParams.subscribe(
    //   v => {
    //     this.spinner.start();
    //     console.log(v);
    //     this.tableName = v.tableName;
    //     console.log(this.tableName)
    //     this.headerNameHtml = v.headerNameHtml;
    //     this.screenType = v.screenType
    //     this.spinner.stop();
    //       console.log(this.screenType)
    //     this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
    //     this.router.navigate(["/user/Menubar/baseComponent"],{queryParams:{screenType:this.screenType,tableName:this.tableName,headerNameHtml:this.headerNameHtml}}));
    //   }
    // )

    //this.dnsDropDown(this.dnsname);
    this.backgroundColorMenuHeader = this.localStorageSettings.getSettings("ColorB");

    this.backgroundColorSideMenu = this.localStorageSettings.getSettings("ColorC");
  
 const res = await (await this.loginService.retrieveVaultConfigDetails(this.localStorageSettings.getSettings("dnsName"))).toPromise();
 console.log(res)
      console.log(res['sessionautorenew']);
      console.log(res['systemName']);
      let systemnameid = res['systemName'];

const response = await (await this.loginService.retrieveSystemName(systemnameid)).toPromise();
if(response['data'].toLowerCase() === 'vault'){
  this.showToggle = true;
  this.toggleValue = res['sessionautorenew'];
      if (res['sessionautorenew'] === "Yes") {
        this.toggleSelect = true;
        this.toolTipStatus = "Turn off Vault session";
        this.confirmationMsg = "Are you sure you want to turn off vault session?"
      } else {
        this.toggleSelect = false;
        this.toolTipStatus = "Turn On Vault session";
        this.confirmationMsg = "Are you sure you want to turn on vault session?"
      }
      console.log(this.toggleSelect);
}else{
  this.showToggle= false;
}

      let vaultVersionLookupvalueid = res['vaultVersion'];
      this.loginService.retrieveLookupvalue(vaultVersionLookupvalueid).subscribe(async response =>{
      this.currentVaultAPIVersion = +response;
     
      })

      const vaultresponse =await (await this.loginService.getAllVaultVersion(this.localStorageSettings.getSettings("vaultDnsname"))).toPromise();
        console.log(vaultresponse)
        if(vaultresponse !==null){
          const vaultVersions = Object.keys(vaultresponse['values']);
          console.log(vaultVersions)
      // Remove 'v' prefix from all elements and parse as floats
  const versionsWithoutV = vaultVersions.map(version => parseFloat(version.substring(1)));
  
  // Find the maximum value
  const maxVersion = Math.max(...versionsWithoutV);
  console.log(maxVersion)
  console.log(this.currentVaultAPIVersion)
  if(maxVersion>this.currentVaultAPIVersion){
    this.showVaultversionAlert = true;
  }
     console.log(this.showVaultversionAlert)
     const currentUrl = this.router.url;
     console.log(currentUrl)
     const parts = currentUrl.split('/'); // Split the string by "/"
     const valueAfterLastSlash = parts[parts.length - 1]; // Get the last element of the array
     console.log(valueAfterLastSlash)
     const params = new URLSearchParams(valueAfterLastSlash.split('?')[1]);
     const tableName = params.get('tableName');

    console.log(tableName);

     if(this.showVaultversionAlert==true && valueAfterLastSlash==="home"){
   
      this.openSnackbar(maxVersion);
    }
    
        }
        

      this.login.username =  this.userName
      this.loginService.getLoginTypeByUser(this.login.username).subscribe(async res=>{
          console.log(res);
		  if(res.data === 'Basic Authentication'){
        const dnsid = this.localStorageSettings.getSettings("dnsName")
      this.etlService.retrieveJsuiteProperty(dnsid, "Idletimeout").subscribe(result => {
      console.log(result);
      if(result === null){
          console.log("Idle Time out property is not configured in Jsuite property")
      }
      else if (result.error===true) {
        console.warn("No Jsuite property data found");
        
      } else {
        
       const lookup = result; // only one item expected
    console.log("Lookup property:", lookup);

    // Everything is in minutes
    const parsed = parseInt(lookup.propertyvalue); // e.g., "12"
    if (!isNaN(parsed) && parsed > 0) {
          this.durationValue = parsed;
        } else {
          console.warn("Invalid property value. Using default 60 minutes.");
        }
        this.timeoutMs = this.durationValue * 60 * 1000;
      console.log(`Idle timeout set to ${this.timeoutMs / 1000}s`);

      this.idleTimeout = this.timeoutMs;
      this.initActivityDetection();
      this.setupBroadcastListener();
      }
      



    });
    

      }
    })
    
        
  }
  private _getChildren = (node: FileNode) => { return observableOf(node.children); };
  hasNestedChild = (_: number, nodeData: FileNode) => { return !(nodeData.urlPath); };


  // getBooks(): TreeviewItem[] {
  //   var childArray=[];
  //   console.log(this.menus)
  //   for(let i=0;i<this.menus.length;i++){
  //     const childrenCategory = new TreeviewItem(this.menus[i]);
  //     childArray.push(childrenCategory)
  //   //  console.log(childArray)
  //  // return [childrenCategory];
  //   }
  //   return childArray;
  // }



  //dynamic routing on selection the screenNames url and path will be forwarded to baseapplication.
  //Chaitanya

  //   routingMethod(urlPath,screenName,screenType){
  //     if(urlPath==null){

  //     }else{
  //     console.log(urlPath)
  //     console.log(screenName)
  //     console.log(screenType)
  //      if(screenType == "Static"){
  //       let url = "/user/Menubar/"+urlPath;
  //       this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
  //     this.router.navigate([url]));
  //     }else{
  //     this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
  //     this.router.navigate(["/user/Menubar/baseComponent"],{queryParams:{tableName:urlPath,headerNameHtml:screenName}}));
  //     }
  //   }
  //  }

  // Logout funtion
  logout() {
    if (confirm("Are you sure you want to logout?") == true) {
      const msalUser:boolean=JSON.parse(this.localStorageSettings.getSettings("msalUser"));
      if(this.isLoggedIn()){
        this.loginService.msalLogoutmethod();
        // this.msalService.logoutRedirect({postLogoutRedirectUri:'http://localhost:4200'})
      }else{
        this.loginService.logoutmethod();
      }
      // calling logout api from login service 
      

    }
  }
  isLoggedIn(): boolean {
     return this.microsoftAuthService.isLoggedIn();
  }
  profileAction(e) {
    console.log(e)
    if (e == "logOut") {
      this.logout();
    }

    else if(e == "aboutUs"){
      this.dialog.open(AboutUsComponent, { width: "40%", height: "70%" });
    }

    else {

      this.dialog.open(ProfileComponent, { width: "50%", height: "80%" });

    }

  }


  dnsDropDown(userid){
    console.log(userid);
      console.log(localStorage.getItem("vaultIds"))
      console.log(localStorage.getItem("defaultVaultId"))
      this.defaultId=+localStorage.getItem("defaultVaultId");
      this.vaultids =JSON.parse(localStorage.getItem("vaultIds"));
      console.log(this.vaultids)
      /*
       Modified By-Abhishek T
       Date-06-12-2023
       Desc-doing empty the dnsnames array to avoid the dns records duplication
      */
       this.dnsnames=[];
      for(let i=0;i<this.vaultids.length;i++){
        if(this.vaultids[i].id === this.defaultId && this.vaultids[i].target===localStorage.getItem("vaultDnsname")){
          this.name = this.vaultids[i].url
          this.defaultLoginDns=this.vaultids[i]
          console.log(this.name)
          this.localStorageSettings.saveSettings("SelectedDnsName",this.vaultids[i].name);
        }
        this.dnsnames.push(this.vaultids[i])
        console.log(this.dnsnames)
      }
  }
 
  selectDns(event){
   console.log(this.defaultLoginDns);
   
    console.log(event)
    console.log(event.substring(8,event.length-4))
    let tempdnschange = event.substring(8,event.length-4);
    let dnschange={
      "dnschange":tempdnschange,
      "username":this.localStorageSettings.getSettings("AuthUsername")
    }
    console.log(dnschange)
    this.spinner.start();
    this.screenService.retrieveselectedDNSofuser(dnschange).subscribe(async res => {
      if (res.error === true) {

        console.log(res);

        this.spinner.stop();

        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        localStorage.clear();
        // finally navigate to login page
        this.spinner.start();
        this.router.navigate(['']);
        this.spinner.stop();
      }
      else {

        console.log(res)
        this.users = res.users;
                this.localStorageSettings.saveSettings("defaultVaultId", res.defaultVaultId);
                this.localStorageSettings.saveSettings("vaultIds", res.vaultIds);
                this.localStorageSettings.saveSettings("dnsName", res.dnsName);
                this.localStorageSettings.saveSettings("vaultDnsname", res.vaultDnsname);
                this.localStorageSettings.saveSettings("AuthToken", res.token);
                this.localStorageSettings.saveSettings("WorkspaceId", res.workspaceId);
        //if successfull it will navigate to user module
       // this.router.navigateByUrl("user");
 
      /**
       * @modified Vijay Badha
       * checking if the user has access to the selected dns if user doesnt have access
       * reverting back to the default dns
       */
       
       this.asignUserRoleService.reteriveuserRoleByTenantIdAndUserId(this.users.userid).subscribe(response => {
        if (response == null) {
          this.spinner.stop();
          this.snackbar.open("The user lacks authorization to view any screen.So changing DNS to "+this.defaultLoginDns.name, 'OK', {duration: 5000});
          alert("The user lacks authorization to view any screen for selected DNS .So changing DNS to "+this.defaultLoginDns.name)
          
          this.selectDns(this.defaultLoginDns.url)
        
        }else if (response.error === true) {

          console.log(response);

          this.spinner.stop();

          this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});

        } else {
           this.spinner.stop();
          this.snackbar.open(res.message, "OK", { duration: 5000 });
          window.location.reload()
        }
      })

        

      }
    })
  
  }



async onToggleChange(event) {
  console.log(this.togglestate)
  const prevoiusTogglestatus = this.toggleSelect;
  let sessionRenewStatus = "";
  this.spinner.start();
console.log(this.toggleSelect)
if(this.toggleSelect){
  sessionRenewStatus = "No"
  this.loginService.deleteSessionRenewSchedular(localStorage.getItem("dnsName"),sessionRenewStatus).subscribe(res=>{
    if(!res.error){
      this.spinner.stop();
      console.log(res)
      this.toggleSelect = !this.toggleSelect
      this.toolTipStatus = "Turn on Vault session";
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    }else{
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    }
  })
}else{
  sessionRenewStatus = "Yes"
  console.log(localStorage.getItem("dnsName"))
  this.loginService.addSessionRenewSchedular(localStorage.getItem("dnsName"),sessionRenewStatus).subscribe(res=>{
    if(res.error){
     
      this.spinner.stop();
      this.toggleSelect = prevoiusTogglestatus; // Revert back to the previous value
      console.log(this.toggleSelect)
      window.location.reload(); 
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });

    }else{
      console.log(res)
      this.toggleSelect = !this.toggleSelect
      this.toolTipStatus = "Turn Off Vault session";
      this.spinner.stop();
      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
    }
  })

  
}

}

showConfirmationMessage(event: MouseEvent) {
  if(this.showToggle){
  var isChecked = this.toggleSelect
  if(this.showToggle === false){
    event.stopPropagation();
  }else{
    if (isChecked) {
      return confirm('Are you sure you want to turn off vault session?');
    }else{
      return confirm('Are you sure you want to turn on vault session?');
    }
  }
}
}



openSnackbar(maxVersion) {
  const duration = 5000;
  const snackbarConfig: MatSnackBarConfig = {
    duration: duration,
    panelClass: ['custom-snackbar']
  };

  const snackbarData = {
    maxVersion: maxVersion // Pass the maxVersion as data
  };

  const snackbarRef = this.snackbar.openFromComponent(VersionAlertComponent, {
    ...snackbarConfig,
    data: snackbarData // Pass the data object
  });

  snackbarRef.onAction().subscribe(() => {
    // Handle the action when the snackbar is dismissed
    console.log('Snackbar dismissed');
  });

}

async initializeData() {
}

storeCatalogCsvRecord(){
  const path = this.router.url;
  const parts = path.split('/');  // Split the string by '/'
const lastPart = parts[parts.length - 1];  // Access the last part
if(lastPart==='home'){
  this.loginService.storeCatalogCsvRecord(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
    console.log(res);
    this.catalogRecords = res;
  })
}
}

storeAuditCatalog(){
  const path = this.router.url;
  const parts = path.split('/');  // Split the string by '/'
const lastPart = parts[parts.length - 1];  // Access the last part
if(lastPart==='home'){
  this.loginService.storeAuditCatalog(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
    console.log(res);
  
  })
}
}

  // ------------------- Idle Detection -------------------
  private initActivityDetection() {
    const activityEvents = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'];
    activityEvents.forEach(event =>
      window.addEventListener(event, () => this.activityDetected())
    );
    this.resetIdleTimer();
  }

  private activityDetected() {
    this.resetIdleTimer();
    this.channel.postMessage('activity'); // Notify other tabs
  }

  private resetIdleTimer() {
    if (this.idleTimer) clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(() => this.logoutDueToInactivity(), this.idleTimeout);
  }

  private logoutDueToInactivity() {
    // alert("Your session has be inactive.Please Login again");
    this.channel.postMessage('logout'); // Notify other tabs
    // this.logout();
     const msalUser:boolean=JSON.parse(this.localStorageSettings.getSettings("msalUser"));
      if(this.isLoggedIn()){
        this.loginService.msalLogoutmethod();
        // this.msalService.logoutRedirect({postLogoutRedirectUri:'http://localhost:4200'})
      }else{
        this.loginService.logoutmethod();
      }
  }

  private setupBroadcastListener() {
    this.channel.onmessage = (event) => {
      this.ngZone.run(() => {
        if (event.data === 'activity') {
          this.resetIdleTimer();
        } else if (event.data === 'logout') {
          // this.logout();
           const msalUser:boolean=JSON.parse(this.localStorageSettings.getSettings("msalUser"));
      if(this.isLoggedIn()){
        this.loginService.msalLogoutmethod();
        // this.msalService.logoutRedirect({postLogoutRedirectUri:'http://localhost:4200'})
      }else{
        this.loginService.logoutmethod();
      }
        }
      });
    };
  }

  
  navigateTo(node: any): void {
  const currentUrl = window.location.href;
console.log(currentUrl);
  if (!node || !node.urlPath) {
    return;
  }

  const isDynamic =
    node.screenType && node.screenType.toString().toLowerCase() === 'dynamic';

  const queryParams: any = {};

  if (isDynamic) {
    // dynamic screens -> baseComponent with query params (includes screenId if present)
    queryParams.tableName = node.urlPath;
    queryParams.headerNameHtml = node.screenName;
    queryParams.screenType = node.screenType;
    if (node.screenId) {
      queryParams.screenId = node.screenId;
    }

    this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/user/Menubar/baseComponent'], { queryParams });
    });

  } else {
    // static screen -> route under /user/Menubar/<urlPath>
    if (node.screenId) {
      queryParams.screenId = node.screenId;
    }

   if (node.screenId) {
  queryParams.screenId = node.screenId; // ✅ REQUIRED
}

const pathSegments = ['user', 'Menubar', node.urlPath];
this.router.navigate(pathSegments, { queryParams });

  }
}


onHelpClick(): void {
  const openUrl = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      this.snackbar.open('Help document not found', 'OK', { duration: 5000 });
    }
  };
  const showError = (err: any) => {
    console.error(err);
    this.snackbar.open('Failed to open help document', 'OK', { duration: 5000 });
  };

  // 1) Prefer explicit screenId from route query params (most reliable)
  const qScreenId = this.route.snapshot.queryParamMap.get('screenId');
  if (qScreenId) {
    const parsed = Number(qScreenId);
    if (!isNaN(parsed)) {
      const nodeById = this.findNodeByScreenId(this.menus, parsed);
      if (nodeById) {
        this.sendHelpRequestForNode(nodeById, openUrl, showError);
        return;
      }
    }
  }

  // 2) Try tableName query param (dynamic screens)
  const tableName = this.route.snapshot.queryParamMap.get('tableName');
  if (tableName) {
    const nodeByTable = this.findNodeByUrlPath(this.menus, tableName);
    if (nodeByTable) {
      this.sendHelpRequestForNode(nodeByTable, openUrl, showError);
      return;
    }
  }

  const urlKey = this.router.url.split('?')[0].split('/').filter(Boolean).pop() || '';
  if (urlKey) {
    const nodeByUrlSeg = this.findNodeByUrlPath(this.menus, urlKey);
    if (nodeByUrlSeg) {
      this.sendHelpRequestForNode(nodeByUrlSeg, openUrl, showError);
      return;
    }
  }

  const headerLabel = this.route.snapshot.queryParamMap.get('headerNameHtml') || '';
  let screenName = headerLabel || '';

  if (!screenName) {
    screenName = urlKey || '';
  }

  if (!screenName) {
    this.snackbar.open('Help unavailable: cannot determine screen name/module', 'OK', { duration: 5000 });
    return;
  }

  const matches = this.findAllNodesByScreenName(this.menus, screenName);

  // If exactly one match — use it
  if (matches.length === 1) {
    this.sendHelpRequestForNode(matches[0], openUrl, showError);
    return;
  }

  
  if (matches.length > 1) {
    // prefer a match whose urlPath equals the router segment or tableName
    const preferred = matches.find(m =>

      (m.urlPath || '').toString().toLowerCase() === (tableName || urlKey || '').toString().toLowerCase()
    );
    if (preferred) {
      this.sendHelpRequestForNode(preferred, openUrl, showError);
      return;
    }

    // still ambiguous — prompt the user to pick one (minimal UI)
    const pickList = matches.map((m, i) => `${i+1}: ${m.screenName} (id=${m.screenId}, url=${m.urlPath || 'n/a'})`).join('\n');
    const choice = window.prompt(`Multiple help pages found for "${screenName}". Pick number:\n${pickList}`, '1');
    const idx = Number(choice) - 1;
    if (!isNaN(idx) && idx >= 0 && idx < matches.length) {
      this.sendHelpRequestForNode(matches[idx], openUrl, showError);
      return;
    }
    // fallback to first
    this.sendHelpRequestForNode(matches[0], openUrl, showError);
    return;
  }

  // No matches at all — send generic payload (server will try slug)
  const moduleName = this.findModuleNameFromCurrentRoute() || '';
  const payload: any = {
    screenCategory: moduleName || undefined,
    screenName: screenName || undefined,
  };
  this.commonService.getHelpLink(payload).subscribe(openUrl, showError);
}
private findNodeByScreenId(nodes: any[], screenId: number): any | null {
  if (!nodes || !Array.isArray(nodes)) return null;
  for (const n of nodes) {
    if (!n) continue;
    if (n.screenId !== undefined && n.screenId !== null && Number(n.screenId) === Number(screenId)) {
      return n;
    }
    if (n.children && Array.isArray(n.children)) {
      const found = this.findNodeByScreenId(n.children, screenId);
      if (found) return found;
    }
  }
  return null;
}
private findAllNodesByScreenName(nodes: any[], name: string): any[] {
  const results: any[] = [];
  if (!nodes || !Array.isArray(nodes) || !name) return results;
  const lower = name.toString().toLowerCase();
  for (const n of nodes) {
    if (!n) continue;
    if ((n.screenName || '').toString().toLowerCase() === lower
      || (n.urlPath || '').toString().toLowerCase() === lower) {
      results.push(n);
    }
    if (n.children && Array.isArray(n.children)) {
      results.push(...this.findAllNodesByScreenName(n.children, name));
    }
  }
  return results;
}
private sendHelpRequestForNode(node: any, onSuccess: (url:string)=>void, onError: (err:any)=>void) {
  const moduleName = this.findTopLevelAncestorLabel(node) || this.findModuleNameFromCurrentRoute() || '';
  const headerName = this.route.snapshot.queryParamMap.get('headerNameHtml') || node?.screenName || '';
  const mod = (moduleName && moduleName.toString().trim()) ? moduleName.toString().trim() : '';
  const name = (headerName && headerName.toString().trim()) ? headerName.toString().trim() : '';
  const sameLabel = mod !== '' && name !== '' && mod.toLowerCase() === name.toLowerCase();
  const rawPath = (mod && name && !sameLabel) ? `${mod}/${name}` : (name || mod || '');
  const payload: any = {
    screenCategory: !sameLabel && mod ? mod : undefined,
    screenName: name || undefined,
    screenPath: rawPath || undefined
  };

  // Send request
  this.commonService.getHelpLink(payload).subscribe(onSuccess, onError);
}



private findModuleNameFromCurrentRoute(): string | null {
  // Don't treat headerNameHtml as module — header is the screen label.
  try {
    // Prefer tableName query param (often used for dynamic screens)
    const tableName = this.route.snapshot.queryParamMap.get('tableName');
    const urlPath = tableName || this.router.url.split('?')[0].split('/').filter(Boolean).pop();

    if (!urlPath) return null;

    // Find node by urlPath (tableName or url segment)
    const node = this.findNodeByUrlPath(this.menus, urlPath);
    if (!node) return null;

    // Return the top-level menu label for the found node
    const top = this.findTopLevelAncestorLabel(node);
    return top || null;
  } catch (e) {
    console.warn('module inference failed', e);
    return null;
  }
}


private findNodeByUrlPath(nodes: any[], urlPath: string): any | null {
  if (!nodes || !Array.isArray(nodes)) return null;
  for (const n of nodes) {
    if (!n) continue;
    if ((n.urlPath || '').toString().toLowerCase() === urlPath.toLowerCase()
        || (n.screenName || '').toString().toLowerCase() === urlPath.toLowerCase()) {
      return n;
    }
    if (n.children && Array.isArray(n.children)) {
      const found = this.findNodeByUrlPath(n.children, urlPath);
      if (found) return found;
    }
  }
  return null;
}

/**
 * Walk up parents to find a top-level menu label for a given node.
 * Assumes nodes have no parent pointer — we search menus to find parent chain.
 */
private findTopLevelAncestorLabel(node: any): string | null {
  // We need to find the path from root menus to this node; easiest is a DFS that returns the chain.
  const chain = this.findNodeChain(this.menus, (n) => n === node);
  if (!chain || !chain.length) return null;
  // chain[0] is top-level menu item
  return chain[0].screenName || chain[0].label || null;
}

private findNodeChain(nodes: any[], matcher: (n: any) => boolean): any[] | null {
  if (!nodes || !Array.isArray(nodes)) return null;
  for (const n of nodes) {
    if (!n) continue;
    if (matcher(n)) return [n];
    if (n.children && Array.isArray(n.children)) {
      const childChain = this.findNodeChain(n.children, matcher);
      if (childChain) {
        return [n, ...childChain];
      }
    }
  }
  return null;
}

//  selectTopNavItem(item: any) {
//   this.selectedTopNavItem = item;

//   // optional: set default active section when menu changes
//   const first = item?.subToolbarItems?.[0];
//   if (first?.section) {
//     this.currentSection = first.section;
//     const pathSegments = ['user', 'Menubar', first.route];
//     this.currentSection= first.section
//     this.router.navigate(pathSegments);
//   }

//   // optional: if you have routing/module change
//   // this.navigate(item.route);
// }


//   handleNavClick(item: any, groupLabel?: string): void {
//     console.log(item);
//     console.log(groupLabel);
//     localStorage.setItem("currentSection", this.currentSection); // save
//     const pathSegments = ['user', 'Menubar', item.route];
//     this.currentSection= item.section
//     this.router.navigate(pathSegments);
//   }
//   getParentLabelByRoute(route: string){
//   for (const parent of this.topNavItems) {
//     if (!parent.subToolbarItems?.length) continue;

//     const match = parent.subToolbarItems.find(
//       sub => sub.route === route
//     );

//     if (match) {
//       return parent; // ✅ parent label
//     }
//   }
//   return null;
// }
// getChildSectionByRoute(route: string): string | null {
//   for (const parent of this.topNavItems) {
//     for (const child of parent.subToolbarItems || []) {
//       if (child.route === route) {
//         return child.section; // ✅ Child section
//       }
//     }
//   }
//   return null;
// }

// ================ MENU PROCESSING for JSIP ================================

/**
 * Normalize function to handle case and special characters
 */
private normalizeModule(str: string): string {
  return str?.toLowerCase().replace(/[^a-z0-9]/g, '') || '';
}

/**
 * Simple icon mapping
 */
private getIconForModule(module: string): string {
  const icons: any = {
    'Home': 'home',
    'Configuration': 'settings',
    'Alerts': 'notification_important',
    'Dictionary': 'find_in_page'
  };
  return icons[module] || 'folder';
}

/**
 * Helper to flatten nested menu items - ONLY include jsip- urls
 */
private flattenJSIPMenuItems(items: any[]): any[] {
  let flat: any[] = [];
  items.forEach(item => {
    // Only include items with urlPath starting with 'jsip-'
    if (item.urlPath && item.urlPath.toString().startsWith('jsip-')) {
      flat.push(item);
    }
    if (item.children?.length) {
      flat.push(...this.flattenJSIPMenuItems(item.children));
    }
  });
  console.log("Flatened JSIP items:", flat);
  return flat;
  
}

/**
 * Sort subToolbarItems by morder if available
 */
private sortSubToolbarItems() {
  this.topNavItems.forEach(item => {
    if (item.subToolbarItems.length > 0) {
      item.subToolbarItems.sort((a: any, b: any) => {
        const morderA = a.morder !== undefined ? a.morder : 999;
        const morderB = b.morder !== undefined ? b.morder : 999;
        
        if (morderA !== morderB) {
          return morderA - morderB;
        }
        
        // If same morder, sort by screenName alphabetically
        return (a.screenName || '').localeCompare(b.screenName || '');
      });
    }
  });
}

/**
 * Main method to process menus and populate top navigation - ONLY JSIP ITEMS
 */
processMenusAndBuildNavigation(menus: any[]) {
  // Reset topNavItems to empty
  this.topNavItems = [];
  
  // 1. Flatten ONLY jsip- menu items
  const jsipMenuItems = this.flattenJSIPMenuItems(menus);
  
  // 2. Get distinct normalized modules from jsip items
  const moduleMap = new Map<string, string>(); // normalized -> original
  jsipMenuItems.forEach(item => {
    if (item.module) {
      const normalized = this.normalizeModule(item.module);
      if (!moduleMap.has(normalized)) {
        moduleMap.set(normalized, item.module);
      }
    }
  });
  
  // 3. Create topNavItems from distinct modules
  moduleMap.forEach((originalModule, normalizedModule) => {
    this.topNavItems.push({
      label: originalModule,
      icon: this.getIconForModule(originalModule),
      section: `${normalizedModule}-section`,
      isRoute: false,
      subToolbarItems: []
    });
  });
  
  // 4. Assign ONLY jsip menu items to their respective modules
  jsipMenuItems.forEach(item => {
    if (item.module) {
      const normalizedItemModule = this.normalizeModule(item.module);
      const targetNav = this.topNavItems.find(nav => 
        this.normalizeModule(nav.label) === normalizedItemModule
      );
      
      if (targetNav) {
        const exists = targetNav.subToolbarItems.some(i => i.urlPath === item.urlPath);
        if (!exists) {
          targetNav.subToolbarItems.push(item);
        }
      }
    }
  });
  
  // 5. Sort items in each toolbar
  this.sortSubToolbarItems();
  
  // 6. Set initial selected navigation
  this.setInitialNavigationFromRoute();
  
  console.log('JSIP Top Navigation Built:', this.topNavItems);
}

/**
 * Set initial navigation based on current route OR saved state
 */
private setInitialNavigationFromRoute() {
  const currentRoute = this.getCurrentRouteSegment();
  
  // First try to restore from localStorage
  const savedSection = localStorage.getItem("currentSection");
  const savedParentLabel = localStorage.getItem("selectedParentLabel");
  
  if (savedParentLabel && savedSection) {
    const savedParent = this.topNavItems.find(item => 
      item.label === savedParentLabel
    );
    
    if (savedParent) {
      const savedItem = savedParent.subToolbarItems?.find(
        (item: any) => item.screenName === savedSection
      );
      
      if (savedItem) {
        this.selectedTopNavItem = savedParent;
        this.currentSection = savedItem.screenName;
        return;
      }
    }
  }
  
  // Fallback to route-based selection
  if (currentRoute) {
    for (const parent of this.topNavItems) {
      const matchingItem = parent.subToolbarItems?.find(
        (item: any) => item.urlPath === currentRoute
      );
      
      if (matchingItem) {
        this.selectedTopNavItem = parent;
        this.currentSection = matchingItem.screenName;
        localStorage.setItem("selectedParentLabel", parent.label);
        localStorage.setItem("currentSection", matchingItem.screenName);
        return;
      }
    }
  }
  
  // Default to first item with subitems
  if (!this.selectedTopNavItem && this.topNavItems.length > 0) {
    const firstWithSubItems = this.topNavItems.find(item => item.subToolbarItems?.length > 0);
    this.selectedTopNavItem = firstWithSubItems || this.topNavItems[0];
    
    if (this.selectedTopNavItem?.subToolbarItems?.[0]) {
      this.currentSection = this.selectedTopNavItem.subToolbarItems[0].screenName;
      localStorage.setItem("selectedParentLabel", this.selectedTopNavItem.label);
      localStorage.setItem("currentSection", this.currentSection);
    }
  }
}

/**
 * Get current route segment
 */
private getCurrentRouteSegment(): string | null {
  const url = this.router.url;
  const parts = url.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart.split('?')[0] || null;
}

/**
 * Restore navigation state from localStorage
 */
private restoreNavigationState(): void {
  const savedParentLabel = localStorage.getItem("selectedParentLabel");
  const savedSection = localStorage.getItem("currentSection");
  
  if (savedParentLabel && savedSection) {
    const parent = this.topNavItems.find(item => item.label === savedParentLabel);
    if (parent) {
      const child = parent.subToolbarItems?.find((item: any) => item.screenName === savedSection);
      if (child) {
        this.selectedTopNavItem = parent;
        this.currentSection = child.screenName;
        return;
      }
    }
  }
  
  this.setInitialNavigationFromRoute();
}

// ================ NAVIGATION METHODS ================

handleNavClick(item: any, groupLabel?: string): void {
  
  localStorage.setItem("currentSection", item.screenName);
  if (groupLabel) {
    localStorage.setItem("selectedParentLabel", groupLabel);
  }
  
  this.currentSection = item.screenName;
  this.router.navigate(['user', 'Menubar', item.urlPath]);

  //Button permission 
  this.screenPermissionServiceService.load(item.urlPath).subscribe();
}

selectTopNavItem(item: any) {
  console.log(item);
  
  this.selectedTopNavItem = item;
  localStorage.setItem("selectedParentLabel", item.label);
  
  const firstItem = item?.subToolbarItems?.[0];
  if (firstItem) {
    this.handleNavClick(firstItem, item.label);
  }
}

/**
 * Get parent label by route
 */
getParentLabelByRoute(route: string) {
  for (const parent of this.topNavItems) {
    const match = parent.subToolbarItems?.find((sub: any) => sub.urlPath === route);
    if (match) return parent;
  }
  return null;
}

/**
 * Get child section by route
 */
getChildSectionByRoute(route: string): string | null {
  for (const parent of this.topNavItems) {
    const match = parent.subToolbarItems?.find((sub: any) => sub.urlPath === route);
    if (match) return match.screenName;
  }
  return null;
}

// Configuration for visible item counts per module
private visibleItemsConfig: { [key: string]: number } = {
  'Home': 8,           // Show 8 items by default for Home
  'Configuration': 6,  // Show 6 items by default for Configuration
  'Dictionary': 8,     // Show 8 items by default for Dictionary
  'Alerts': 8,         // Show 8 items by default for Alerts (if exists)
  // Add more modules as needed, default will be 8 if not specified
};

/**
 * Get visible items for a module (limited by config)
 */
getVisibleItems(module: any): any[] {
  if (!module?.subToolbarItems) return [];
  
  const limit = this.visibleItemsConfig[module.label] || 6; // Default to 6
  return module.subToolbarItems.slice(0, limit);
}

/**
 * Get hidden items for a module (items beyond the limit)
 */
getHiddenItems(module: any): any[] {
  if (!module?.subToolbarItems) return [];
  
  const limit = this.visibleItemsConfig[module.label] || 6;
  return module.subToolbarItems.slice(limit);
}

/**
 * Check if any hidden item is currently active
 */
isDropdownItemActive(module: any): boolean {
  const hiddenItems = this.getHiddenItems(module);
  return hiddenItems.some(item => item.screenName === this.currentSection);
}

selectCategory(category: string) {
  this.selectedCategory = category;
  this.alertList=[]
      this.productList = [];
       this.reviewActivtyList=[];
   this.showSuggestions = false;
}

onSearchInput() {
  clearTimeout(this.searchTimer);

  this.searchTimer = setTimeout(() => {
    const text = this.searchText?.trim();

    if (this.selectedCategory === 'Products' && text) {
       this.productList = [];
      this.searchProducts(text);
    }else if(this.selectedCategory === 'Signals' && text){
       this.productList = [];
      this.searchSignals(text)
    }else if(this.selectedCategory === 'Review Activities' && text){
       this.productList = [];
      this.searchReviewActivities(text)
    }else if(this.selectedCategory === 'Alerts' && text){
       this.productList = [];
      this.searchAlerts(text)
    }
  }, 400); // debounce
}

searchProducts(searchValue: string) {
  this.globalSearchService.searchProducts(searchValue).subscribe({
    next: (res) => {
      console.log('Search result:', res);
      // bind result to dropdown/grid here
      this.productList=res
      this.showSuggestions = true;
    },
    error: (err) => {
      this.productList = [];
      console.error('Search API error:', err);
    }
  });
}

searchSignals(searchValue: string) {
  this.globalSearchService.searchSignals(searchValue).subscribe({
    next: (res) => {
      console.log('Search result:', res);
      // bind result to dropdown/grid here
      this.productList=res
      this.showSuggestions = true;
    },
    error: (err) => {
      this.productList = [];
      console.error('Search API error:', err);
    }
  });
}

searchAlerts(searchValue: string) {
  this.globalSearchService.searchAlertRules(searchValue).subscribe({
    next: (res) => {
      console.log('Search result:', res);
      // bind result to dropdown/grid here
      this.alertList=res
      this.showSuggestions = true;
    },
    error: (err) => {
      this.alertList=[]
      this.productList = [];
       this.reviewActivtyList=[];
      console.error('Search API error:', err);
    }
  });
}

searchReviewActivities(searchValue: string) {
  this.globalSearchService.searchReviewActivity(searchValue).subscribe({
    next: (res) => {
      console.log('Search result:', res);
      // bind result to dropdown/grid here
      this.reviewActivtyList=res
      this.showSuggestions = true;
    },
    error: (err) => {
      this.productList = [];
      this.reviewActivtyList=[];
      console.error('Search API error:', err);
    }
  });
}

handleNavClickForGlobalSearch(item: any,selectedData:any,groupLabel?: any): void {
  this.searchText=""
   this.selectedTopNavItem = groupLabel;
  localStorage.setItem("currentSection", item.screenName);
  if (groupLabel) {
    localStorage.setItem("selectedParentLabel", groupLabel.label);
  }
  
  
  this.currentSection = item.screenName;
  this.router.navigate(['user', 'Menubar', item.urlPath],
    {
    state: {
      selectedRowData: selectedData
    }
  }
  );

  //Button permission 
  this.screenPermissionServiceService.load(item.urlPath).subscribe();
}
findMenuByUrlPath(urlPath: string) {
  for (const parent of this.topNavItems) {
    const child = parent.subToolbarItems?.find(
      (item: any) => item.urlPath === urlPath
    );

    if (child) {
      return {
        parentLabel: parent,
        object: child
      };
    }
  }
  return null;
}
selectProduct(product: any) {
  console.log(product)
  this.searchText = product.name__v;
  this.showSuggestions = false;

  console.log('Selected product:', product);
  console.log(this.topNavItems);
  
   if (this.selectedCategory === 'Products') {
    
      const result = this.findMenuByUrlPath("jsip-librarysupport")
      this.handleNavClickForGlobalSearch(result.object,product,result.parentLabel)
    }else if(this.selectedCategory === 'Signals'){
      const result = this.findMenuByUrlPath("jsip-signals")
      this.handleNavClickForGlobalSearch(result.object,product,result.parentLabel)
      // this.router.navigate(['user', 'Menubar', "jsip-signals"]);
    //Button permission 
    // this.screenPermissionServiceService.load('jsip-signals').subscribe();
    }

}

selectAlert(alert: any) {
  console.log(alert)
  // this.searchText = product.name__v;
   const result = this.findMenuByUrlPath("jsip-alertscreen")
      this.handleNavClickForGlobalSearch(result.object,alert,result.parentLabel)
  this.showSuggestions = false;

  console.log('Selected product:', alert);

}

selectSignal(signal: any) {
  console.log(alert)
  // this.searchText = product.name__v;
  this.showSuggestions = false;
 this.router.navigate(['user', 'Menubar', "jsip-signals"]);

  //Button permission 
  this.screenPermissionServiceService.load('jsip-signals').subscribe();
  console.log('Selected product:', alert);

}
selectReviewActivity(activity:any){
     const result = this.findMenuByUrlPath("jsip-reviewactivities")
      this.handleNavClickForGlobalSearch(result.object,activity,result.parentLabel)
  this.showSuggestions = false;

  console.log('Selected product:', activity);
}

closeSuggestions(){
   this.showSuggestions =false;
}
}
